<template>
  <modal
    name="modal--edit-locations"
    transition="nice-modal-fade"
    :click-to-close="false"
    :width="400"
    :height="'auto'"
    :adaptive="true"
    :reset="true"
    :scrollable="true"
    draggable=".drag-handler"
    @before-open="beforeOpen"
    @before-close="beforeClose"
    class="py-10"
  >
    <div
      class="flex flex-col text-black h-full overflow-hidden w-full bg-white rounded-sm justify-between p-4"
    >
      <div
        class="text-center text-3xl mb-4 mt-4 font-extralight tracking-tight drag-handler"
      >
        Product Locations
      </div>

      <div class="text-xl">
        <form @submit.prevent="handleConfirm">
          <todo-list
            ref="productLocationList"
            :label="''"
            placeholder="Add Location"
            :validation-type="'text'"
            :list="data.productLocations"
            :readonly="!isAdmin"
            @add="add"
            @remove="remove"
            class="text-base font-normal normal-case"
          />
          <div class="button-set flex flex-row justify-between mt-10">
            <button
              class="buttonOutline focus:shadow-outline focus:outline-none"
              @click.prevent="$modal.hide('modal--edit-locations')"
            >
              Cancel
            </button>

            <button
              v-if="isAdmin"
              class="button focus:shadow-outline focus:outline-none"
              type="submit"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import TodoList from '@/components/TodoList'

export default {
  name: 'ModalEditLocations',
  data() {
    return {
      data: {
        productLocations: []
      }
    }
  },
  components: {
    TodoList
  },
  computed: {
    ...mapGetters('global', { productLocations: 'settingsProductLocations' }),
    ...mapGetters('user', ['isAdmin'])
  },
  methods: {
    ...mapActions('config', ['setFabVisible', 'setDragLock']),
    ...mapActions('global', ['updateSettings']),
    beforeOpen() {
      this.data.productLocations = [...(this.productLocations || [])]
      this.setFabVisible(false)
      this.setDragLock(true)
    },
    beforeClose() {
      this.setFabVisible(true)
      this.setDragLock(false)
    },
    add(i) {
      this.data.productLocations.push(i)
    },
    remove(i) {
      let index = this.data.productLocations.indexOf(i)
      if (index > -1) this.data.productLocations.splice(index, 1)
    },
    handleConfirm() {
      if (this.productLocations != this.data.productLocations) {
        this.updateSettings({ productLocations: this.data.productLocations })
      }
      this.$modal.hide('modal--edit-locations')
    }
  }
}
</script>
